export default {
  getHead: () => {
    return [{name: '현장명'}, {name: '예산 누계'}, {name: '당월사용금액 누계'}, {name: '누계사용금액'}, {name: '집행율 누계'}, {name: '소속명'}, {name: '부서명'}, {name: '작성자'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 현장명
      case 1: return func.getContent(value).total.value1 // 예산 누계
      case 2: return func.getContent(value).total.value2 // 당월사용금액 누계
      case 3: return func.getContent(value).total.value3 // 누계사용금액
      case 4: return func.getContent(value).total.value4 // 집행율 누계
      case 5: return func.getContent(value).stdInfo.department // 소속명
      case 6: return func.getContent(value).stdInfo.section ? func.getContent(value).stdInfo.section : func.getContent(value).stdInfo.com_name // 부서명
      case 7: return func.getContent(value).stdInfo.writer_name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType,  searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
    case '현장명': return ['content$body.stdInfo.field_name*%[:default_skw]%']
    case '예산 누계': return ['content$body.total.value1*%[:default_skw]%']
    case '당월사용금액 누계': return ['content$body.total.value2*%[:default_skw]%']
    case '누계사용금액': return ['content$body.total.value3*%[:default_skw]%']
    case '집행율 누계': return ['content$body.total.value4*%[:default_skw]%']
    case '소속명': return ['content$body.stdInfo.department*%[:default_skw]%']
    case '부서명': return ['content$body.stdInfo.com_name*%[:default_skw]%']
    case '작성자': return ['content$body.stdInfo.writer_name*%[:default_skw]%']
    }

    return []
  },
}
